import axios from "axios";
import { getAuthToken } from "../context/AuthContext";

const baseUrl = process.env.REACT_APP_BACKEND_URL + "api/tickets";

const api = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const useTickets = () => {
  // Company functions
  const getCompanyTickets = async () => {
    try {
      const response = await api.get("/");
      return response.data;
    } catch (error) {
      console.error("Error fetching company tickets:", error);
      throw error;
    }
  };

  const getTicketById = async (ticketId) => {
    try {
      const response = await api.get(`/${ticketId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ticket ${ticketId}:`, error);
      throw error;
    }
  };

  const createTicket = async (ticketData) => {
    try {
      const response = await api.post("/", ticketData);
      return response.data;
    } catch (error) {
      console.error("Error creating ticket:", error);
      throw error;
    }
  };

  // Admin functions
  const getAllTickets = async () => {
    try {
      const response = await api.get("/all");
      return response.data;
    } catch (error) {
      console.error("Error fetching all tickets:", error);
      throw error;
    }
  };

  const getTicketsByStatus = async (status) => {
    try {
      const response = await api.get(`/status/${status}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching tickets with status ${status}:`, error);
      throw error;
    }
  };

  const updateTicketStatus = async (ticketId, status) => {
    try {
      const response = await api.put(`/${ticketId}/status`, { status });
      return response.data;
    } catch (error) {
      console.error(`Error updating ticket ${ticketId} status:`, error);
      throw error;
    }
  };

  const updateTicket = async (ticketId, ticketData) => {
    try {
      const response = await api.put(`/${ticketId}`, ticketData);
      return response.data;
    } catch (error) {
      console.error(`Error updating ticket ${ticketId}:`, error);
      throw error;
    }
  };

  const deleteTicket = async (ticketId) => {
    try {
      await api.delete(`/${ticketId}`);
    } catch (error) {
      console.error(`Error deleting ticket ${ticketId}:`, error);
      throw error;
    }
  };

  return {
    getCompanyTickets,
    getTicketById,
    createTicket,
    getAllTickets,
    getTicketsByStatus,
    updateTicketStatus,
    updateTicket,
    deleteTicket,
  };
};

export default useTickets;
